import * as THREE from 'three';
import {createAtlasSprite} from './pixelAssets';
import {MAGIC_ATLAS} from './artAtlas';
import {CHIP_DEFS,type ChipId} from './config';

type Family=0|1|2|3;
interface Animation {sprite:THREE.Sprite;frames:THREE.Texture[];age:number;duration:number;size:number;family:Family;follow:()=>{x:number;y:number};loop:boolean;id:ChipId|string;owner:number}
const FAMILY:Record<ChipId,Family>={magnet:1,blast:0,twinHook:2,timeDilation:2,gravityFlip:2,goldFever:3,pocketClock:3,seedPouch:3,lantern:0,mossShield:1,surveyLens:1,starElixir:3,rescueBell:2,ropeShears:2};

export class MagicEffects {
  private readonly frames:THREE.Texture[][]=[];
  private readonly animations:Animation[]=[];
  private time=0;
  lastTool:ChipId|null=null;
  constructor(private scene:THREE.Scene){
    for(let row=0;row<4;row++){
      const frames=[];
      for(let f=0;f<4;f++){const s=createAtlasSprite(MAGIC_ATLAS,row*4+f,1);frames.push(s.material.map!);s.material.dispose();}
      this.frames.push(frames);
    }
  }
  get count():number{return this.animations.length;}
  private add(family:Family,id:Animation['id'],duration:number,size:number,follow:Animation['follow'],loop=false,owner=-1):void {
    const sprite=new THREE.Sprite(new THREE.SpriteMaterial({map:this.frames[family][0],transparent:true,depthWrite:false,depthTest:false,opacity:.85}));
    sprite.renderOrder=12;this.scene.add(sprite);this.animations.push({sprite,frames:this.frames[family],age:0,duration,size,family,follow,loop,id,owner});
    this.position(this.animations[this.animations.length-1],false);
  }
  activate(id:ChipId,owner:number,pivot:{x:number;y:number},hook:()=>{x:number;y:number}):void {
    this.lastTool=id;this.stop(id,owner);this.update(0,false);
    const family=FAMILY[id],colour=id==='magnet'?'#b7e9ee':id==='timeDilation'?'#d3b8ed':'#ffffff';
    this.add(family,id,1,3.2,id==='ropeShears'?hook:()=>pivot,false,owner);this.animations[this.animations.length-1].sprite.material.color.set(colour);
    if(['magnet','blast','twinHook','timeDilation','gravityFlip','seedPouch','lantern','mossShield','surveyLens','starElixir','goldFever'].includes(id)){
      const duration=id==='blast'||id==='starElixir'||id==='goldFever'?3600:CHIP_DEFS[id].duration||8;
      const target=['magnet','blast','surveyLens','twinHook','mossShield'].includes(id)?hook:()=>pivot;
      this.add(family,id,duration,id==='mossShield'?2.9:id==='lantern'?4.2:2.2,target,true,owner);
      this.animations[this.animations.length-1].sprite.material.color.set(colour);
    }
  }
  impact(x:number,y:number):void {this.add(0,'impact',.8,4.2,()=>({x,y}));}
  reward(x:number,y:number):void {this.add(3,'reward',.75,2.2,()=>({x,y}));}
  stop(id:ChipId,owner:number):void {for(const a of this.animations)if(a.id===id&&a.owner===owner)a.age=a.duration;}
  update(dt:number,reduced:boolean):void {
    this.time+=dt;
    for(let i=this.animations.length-1;i>=0;i--){const a=this.animations[i];a.age+=dt;if(a.age>=a.duration){this.scene.remove(a.sprite);a.sprite.material.dispose();this.animations.splice(i,1);continue;}this.position(a,reduced);}
  }
  private position(a:Animation,reduced:boolean):void {
    const p=a.follow(),phase=a.loop?(a.age%1.2)/1.2:a.age/a.duration;
    a.sprite.material.map=a.frames[reduced?1:Math.min(3,Math.floor(phase*4))];
    a.sprite.position.set(p.x,p.y,1.2);
    const scale=a.size*(reduced?1:a.loop?1+Math.sin(this.time*4)*.07:1+phase*.3);
    a.sprite.scale.set(scale,scale,1);
    a.sprite.material.opacity=a.loop?(reduced?.32:.45):.85*(1-phase);
  }
  clear():void {for(const a of this.animations){this.scene.remove(a.sprite);a.sprite.material.dispose();}this.animations.length=0;this.lastTool=null;this.time=0;}
  dispose():void {this.clear();}
}
